<template>
  <div>
    <div class="navbar">
      <img class="mx-auto" src="../assets/Image/pic_logo_live720.png" alt="LiveVR 720">
    </div>

    <div class="banner">
      <img class="m-auto" src="../assets/Image/pic_logo_sahmyook.png">
    </div>

    <main class="main-bg">
      <div class="container py-2">
        <h4 class="py-4 ">Live720 Gallery</h4>
        <div v-if="list" class="row mx-auto" style="width:90%">
          <div v-for=" item in list" :key="item.id" class="col-md-3 col-sm-6 p-2">
            <a class="card-img" @click="$router.push({ path: '/viewer/' + item.id, params: { 'id': item.id }})">
              <img class="thumbnail" :src="item.thumbnail" style="width:100%" alt="..." v-if="item.thumbnail">
              <switchImg :inputName="item.name" v-else/>
            </a>
          </div>
        </div>
      </div>
    </main>

    <footer class="footer_bg">
      <div class="footer-content">
        <span class="footer-line"></span>
          <span class="footer-title">
            Service
          </span>
        <span class="footer-line"></span>
        </div>
        <div>
          <ul>
            <li>Phone:(+886)225782626</li>
            <li class="none">|</li>
            <li>Office Hours:Mon ~ Fri 09:00 ~ 18:00</li>
            <li class="none">|</li>
            <li>email:service@liveabc.com</li>
          </ul>
        </div>
        <p>Copyright@Heborn Soft Limited. All Rights Reserved</p>
    </footer>
  </div>
</template>

<script>

// @ is an alias to /src
import axios from 'axios'
import switchImg from '@/components/SwitchImg.vue'

export default {
  name: 'koreaIndex',
  components: {
    switchImg
  },
  data () {
    return {
      list: null
    }
  },

  async mounted () {
    let self = this
    this.login('samyookvr', '123456').then(() => {
      axios.get('https://istaging.hongdoujiao.com﻿/api/v1/panoCollection').then((data) => {
        self.list = data.data || []
      })
    })
  },
  methods: {
    async login (username, password) {
      const { data } = await axios.post('https://istaging.hongdoujiao.com﻿/api/v1/tenant/login', {
        'username': username,
        'password': password
      })

      axios.defaults.headers.common['tenantId'] = data.id
      axios.defaults.headers.common['tenant-token'] = data.tenantToken
    }
  }
}
</script>

<style lang="scss" scoped>
  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
  .navbar {
    position: absolute;
    width: 80%;
    margin: 0 10%;
    color: #ffffff;
  }
  .banner {
    height: 100vh;
    padding: 30px;
    color: #ffffff;
    background-image: url('../assets/Image/pic_main_bg.jpg');
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
  }
  .main-bg {
    background-color: #f5f5f5;
  }
  .thumbnail {
    border-radius: 10px;
  }
  .footer_bg {
    background-color: #ffffff;
    color: #4750f8;
    padding-top: 1rem;
    width: 100%;
    .footer-content,p,ul {
      text-align: center;
      padding-bottom: 1rem;
      margin: 0;
    }
    .footer-line {
      display: inline-block;
      width: 30vw;
      border-top: 1px solid #4750f8;
    }
    .footer-title {
      margin: 1rem;
      width: 80%;
      font-family: Microsoft JhengHei;
      font-weight:bold;
      font-size: 1rem;
      vertical-align: -4px;
    }
    @media screen and (min-width: 600px){
      ul {
        display: flex;
        justify-content:center;
      }
      .none{
        display: block !important;
      }
    }
    li {
      font-size: 1rem;
      list-style:none;
      margin: 10px 20px;
    }
    .none {
      display: none;
    }
  }

  a.card-img {
    cursor: pointer;
  }
</style>
